// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModalReSyncGrades__modal__cH61e {\n   margin-top: 10%;\n}\n", "",{"version":3,"sources":["webpack://./../shared/components/ModalReSyncGrades/style.css"],"names":[],"mappings":"AAAA;GACG,eAAe;AAClB","sourcesContent":[".modal {\n   margin-top: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "ModalReSyncGrades__modal__cH61e"
};
export default ___CSS_LOADER_EXPORT___;
